<template>
    <div class="register">
        <!-- <div class="reg-button" @click="showRegisterPanel">注册</div>-->
        <!-- close-on-click-modal 参数设置是不允许点击空白处关闭窗口 -->
        <el-dialog
            title="注册"
            :visible.sync="isShow"
            :before-close="hide"
            :append-to-body="true"
            :modal-append-to-body="true"
            :close-on-click-modal="false"
            center>
            <div align="center" style="width:100%;border:0px solid black">
                <!-- 用户名，邮箱地址，密码，密码，已有账户，点击登录-->
                <el-form ref="vform" :model="vform" status-icon :rules="rules" :auto-upload="false" label-width="80px" :disabled="vform.disable">
                    <el-form-item prop='email' label="邮箱">
                        <el-input type="email" v-model="vform.email" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input type="password" v-model="vform.password" autocomplete="off" show-password></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="checkPassword" style="margin-bottom:10px"> <!-- 缩减 margin-bottom 的距离，为 username 调整出合理的展示空间-->
                        <el-input type="password" v-model="vform.checkPassword" autocomplete="off" show-password></el-input>
                    </el-form-item>
                    <el-form-item id="username" prop="username" label="用户名" :style="{marginBottom: usernameMarginBottom+'px'}"> <!-- 缩减 margin-bottom 的距离，为 username 调整出合理的展示空间-->
                        <!-- 外层 div 样式说明: 与 lable 用户名等高 40；使得 el-radio 与 lable 用户名高度居中显示 -->
                        <div style="display: flex;align-items: center; height:40px;" align="left">
                            <!-- radio 和文字之间不等高，结果发现 radio 中使用了 vertical-align，抱着试试的心态，发现的确可用 -->
                            <el-radio v-model="radio" :label="0" @change="checked" class="el-radio-mystyle"><div style="font-size:14px">系统自动生成</div></el-radio>
                            <el-radio v-model="radio" :label="1" @change="checked" class="el-radio-mystyle">我要自己填写</el-radio>
                        </div>
                        <div v-show="isShowUsernameInputEle">
                            <el-input ref="username" type="text" v-model="vform.username" autocomplete="off"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="邀请码" prop="inviteCode" ref="inviteCode" v-if="isDisplayInviteCode">
                        <el-input type="inviteCode" v-model="vform.inviteCode" autocomplete="off" placeholder="输入邀请码兑换积分"></el-input>
                        <div class="el-form-item__success" v-show="inviteCode.showSuccess">{{inviteCode.successMessage}}</div>
                    </el-form-item>
                    <el-form-item label="同意协议" prop="aggrement" style="margin-top:-10px">
                        <div align="left">
                            <el-checkbox v-model="vform.aggrement"
                                >《<my-link @click.native="showAggrement('service')">用户协议</my-link
                                >》和《<my-link @click.native="showAggrement('privacy')">隐私协议</my-link>》
                            </el-checkbox>
                        </div>
                    </el-form-item>
                    <el-form-item style="width: 100%">
                        <el-button type="danger" @click="submitForm('vform')">提交</el-button>
                        <el-button @click="resetForm('vform')">重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="reg-footer" align="left">
                    <!-- trigger register -->
                    <span>已有账户，</span><el-link type="primary" :underline='false' @click="toLogin">点击</el-link><div class="margin-right-8px">登录</div>
                    <span>|</span>
                    <!-- trigger find password back -->
                    <el-link type="primary" :underline='false' class="margin-left-8px" @click="toFindPassword">点击</el-link><span>找回密码</span>
                </div>
            </div>
        </el-dialog>
        <show-aggrement ref="aggrementDialog"></show-aggrement>
    </div>
</template>

<script>
    import {
        validateUsername1,
        validatePassword,
        validatePassword2,
        validateEmail,
        validateInviteCode,
        validateAggrement
    } from "../../../validator";
    import env from "../../../../config/env";
    import ShowAggrement from "../../commons/ShowAggrement";
    import {register} from "../../../data/user";
    import {errorMessage, GlobalLoading, successMessage, Styles} from "../../../utils";

    const USERNAME_AUTO = 0;
    const USERNAME_MANUAL = 1;

    export default {
        name: "Register",
        components: {ShowAggrement},
        data() {
            return {
                isShow: false,
                isShowUsernameInputEle: false,
                usernameMarginBottom: 10,
                radio: USERNAME_AUTO,  // 0 means system auto gen username, 1 means the user input the username
                inviteCode: {
                    showSuccess: false,
                    successMessage: null
                },
                vform: {
                    email: null,
                    username: null,
                    password: null,
                    checkPassword: null,
                    inviteCode: null,
                    aggrement: false,
                    disable: false
                },
                rules: {
                    email: [
                        { required: true, validator: validateEmail.bind(this), trigger: ['blur', 'change'] } // 通过 bind 将 this 传入
                    ],
                    // 注意，password 验证的时候，不要使用 blur，否则成功失败标志和查看密码提示标志冲突
                    password: [
                        { required: true, validator: validatePassword.bind(this), trigger: 'change' } // 通过 bind 将 this 传入
                    ],
                    checkPassword: [
                        { required: true, validator: validatePassword2.bind(this), trigger: 'change' }
                    ],
                    username: [
                        { required: true, validator: validateUsername1.bind(this), trigger: ['blur', 'change'] } // 通过 bind 将 this 传入
                    ],
                    inviteCode: [
                        { required: false, validator: validateInviteCode.bind(this), trigger: 'blur' }
                    ],
                    aggrement: [
                        { required: true, validator: validateAggrement.bind(this), trigger: 'change' }
                    ]
                }
            }
        },
        watch: {
            // 监听 radio 值的目的其实就是为了隐藏 username error lable 而已，如果用户输入用户名错误，提示错误，但是想用系统生成了，这个时候就必须手动隐藏该 error lable 了，
            radio (val){
                if(val === USERNAME_AUTO){ // the system auto generate the username, hide the error and the input ele
                    this.isShowUsernameInputEle = false;
                    // 写这个方法的主要目的就是 hide the error div tag.
                    let errLable = document.querySelector("#username .el-form-item__error");
                    console.log('err lable', errLable);
                    if (errLable)
                        errLable.style.display = 'none';
                    this.usernameMarginBottom = 10
                }else if(val === USERNAME_MANUAL) {  // the user input the username, display the input ele and the error lable if has
                    this.isShowUsernameInputEle = true;
                    let errLable = document.querySelector("#username .el-form-item__error");
                    if (errLable)
                        errLable.style.display = 'unset';
                    this.usernameMarginBottom = 20
                }else{
                    throw Errror('malform');
                }
            }
        },
        computed: {
            // 网上有人说，invite code 苹果不允许，因此作为敏感内容后端配置展示
            isDisplayInviteCode(){
                return this.$store.state.displayCtrl === null ? false : this.$store.state.displayCtrl.inviteCode;
            }
        },
        methods: {
            showRegisterPanel(){
                this.isShow = true;
                Styles.disableBodyScroll();
            },
            hide(){
                this.isShow = false;
                Styles.enableBodyScroll();
            },
            formUrl(){
                return `${env.BACKEND_BASE_URL()}/u/reg`;
            },
            // the username radio checked method.
            checked(val) {
                if(val === USERNAME_MANUAL){
                    this.inputDisable = false;
                    this.$nextTick(()=>{
                        this.$refs.username.focus();  // 要在 next tick 中才能生效。
                    })
                }else{
                    this.inputDisable = true;
                }
            },
            /**
             * 这里的 loading 逻辑与
             * @param formName
             */
            submitForm(formName) {
                // 这里的 loading 逻辑与 Login 不同，核心区别是，这里提交表单需要异步远程检查，因此更为耗时，所以需要把 loading 放得更靠前，否则页面像假死一样。
                this.vform.disable = true;
                GlobalLoading.start();
                this.$refs[formName].validate(function(valid){
                    if (valid) {
                        async function exec(){
                            try{
                                let username = null;
                                if (this.radio === USERNAME_MANUAL)
                                    username = this.vform.username;
                                let r = await register.bind(this)(this.vform.email, this.vform.password, username, this.vform.inviteCode);
                                console.log('submit register return', r);
                                if(r.success){
                                    this.$parent.isSignedIn = true;
                                    this.hide();
                                    successMessage('注册成功，欢迎您！');
                                }
                            }catch(err){
                                console.error(err);
                                errorMessage(err.message);
                            }finally{
                                this.vform.disable = false;
                                GlobalLoading.stop();
                            }
                        }
                        exec.bind(this)();
                    } else {
                        this.vform.disable = false;
                        GlobalLoading.stop();
                        return false;
                    }
                }.bind(this));
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            toLogin(){
                this.isShow = false;
                setTimeout(function(){
                    this.$parent.$refs.login.isShow = true;
                }.bind(this), 200);  // 给一个 timeout 的时间，不然转换太快了。
            },
            toFindPassword(){
                this.isShow = false;
                setTimeout(function(){
                    this.$parent.$refs.findPassword.isShow = true;
                }.bind(this), 200);  // 给一个 timeout 的时间，不然转换太快了。
            },
            showAggrement(type){
                if (type === 'service'){
                    let url = 'https://huocool.kufan.site/aggrements/user-aggrement.html'
                    this.$refs.aggrementDialog.show(url)
                } else if (type === 'privacy'){
                    let url = 'https://huocool.kufan.site/aggrements/privacy-aggrement.html'
                    this.$refs.aggrementDialog.show(url)
                }
            }
        }
    }
</script>

<style scoped>

    .register .reg-button{
        cursor: pointer
    }

    .register .reg-button:hover{
        color: #CB0101
    }

    .reg-footer{
        display:inline-flex;
        width: 100%;
        line-height: 22px;
    }

    /* 设置 form field 输入成功的图标样式 */
    /deep/ .el-icon-circle-check:before{
        color: #67C23A;
        content: "\E720";
    }

    /deep/ .el-dialog{
        width: 468px;  /* 主页展示的最大宽度的一半 */
    }

    .el-form-item__success{
        color: #67C23A;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        top: 100%;
        left: 0;
    }


    @media (min-width: 800px) and (max-width: 1100px){
        /deep/ .el-dialog{
            width: 50%;
        }
    }

    @media (min-width: 736px) and (max-width: 799px){
        /deep/ .el-dialog{
            width: 60%;
        }
    }

    @media (max-width: 735px){
        /deep/ .el-dialog{
            width: 80%;
        }
    }

    @media (min-width: 320px) and (max-width: 540px){
        /deep/ .el-dialog{
            width: 100%;
        }
    }

    /deep/ .el-radio{
        font-size: 14px !important;
        font-weight: 400 !important;
        margin: 0 !important;
        padding: 5px 20px 5px 0 !important;
    }

    /deep/ .el-radio__label{
        padding-left: 5px;
    }

    /deep/ .el-radio__input.is-checked+.el-radio__label{
        color: #606266;
    }

    /* ==========>>>> 解决 radio item 与文字不对齐的问题 <<<<========== */

    .el-radio-mystyle {
        display:inline-flex;
        display: -webkit-inline-flex;
        align-items:center;
    }

    /deep/ .el-radio__input{
        line-height: 1px !important; /* 不要问我为什么，反正这里设置为了 1px radio 和 text 就居中对齐了 */
    }

    /* 解决 checkbox 选中后字体变蓝的问题 */
    /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
        color: black
    }

    /* ==========>>>> 解决 radio item 与文字不对齐的问题 <<<<========== */

    /* 调整 el-dialog 的样式 */
    /*/deep/ .el-dialog--center .el-dialog__body{*/
    /*    padding: 2px 10px 10px*/
    /*}*/
</style>



// WEBPACK FOOTER //
// src/components/user/login/Register.vue